import React, { useEffect } from 'react';

import useHidePhiHotkey from '@/hooks/useHidePhiHotkey';
import useScreenshotPhiBlur from '@/hooks/useScreenshotPhiBlur';
import { applyStoredHidePhi, syncHidePhiAcrossTabs } from '@/services/hidePhiStore';

import './styles.css';
import type { Props } from './types';

/**
 * Headless: owns the page-wide listeners that blur `.mp-sensitive` PHI. It is mounted once at the
 * app root so the shortcut and the screenshot blur work whichever nav is on screen.
 */
const PhiBlurController = (_props: Props) => {
  useScreenshotPhiBlur();
  useHidePhiHotkey();

  useEffect(() => {
    applyStoredHidePhi();
    return syncHidePhiAcrossTabs();
  }, []);

  return null;
};

export default React.memo(PhiBlurController);
